<section class="error-area">
  <div class="error-item">
      <div class="d-table">
          <div class="d-table-cell">
              <div class="error-text">
                  <h1>OOPs!</h1>
                  <p>Sorry! Work in Progress...</p>
                  <span>Please bear with us as this feature will soon be implemented.</span>
                  <a routerLink="/">Return to Home</a>
              </div>
          </div>
      </div>
  </div>
</section>
